import React, { useState, useMemo, Suspense } from "react";
import themePropTypes from "../../theme-prop-types";

const Input = React.lazy(() => import("react-phone-number-input/input"));

export const getPhoneNumberWithCountryCode = ({ countryCode, phoneNumber }) =>
  phoneNumber && phoneNumber[0] !== "+"
    ? `+${countryCode}${phoneNumber}`
    : phoneNumber;

const ModernizedPhoneInput = ({
  id,
  labelId,
  name,
  params = "",
  values,
  onUpdate,
  isInvalid,
  defaultCountry = "US",
  placeholder,
  testAttributes
}) => {
  const [phoneNumber, setPhoneNumber] = useState(values[name]);

  const className = useMemo(
    () => name + params?.split("|").join(" ") + (isInvalid ? " invalid" : ""),
    [name, params, isInvalid]
  );

  const updateNumberHandler = newValue => {
    if (newValue) {
      setPhoneNumber(newValue);
      onUpdate(name, newValue);
    } else {
      newValue = "";
      setPhoneNumber(newValue);
      onUpdate(name, newValue);
    }
  };

  const onBlurNumberInput = () => onUpdate(name, phoneNumber);

  return (
    <div className={`websdk-modernized-phone-number-input ${className}`}>
      <Suspense fallback={null}>
        <Input
          id={id}
          name={name}
          placeholder={placeholder}
          className={`modernized-input-web-sdk  ${className}`}
          defaultCountry={defaultCountry}
          international={false}
          withCountryCallingCode
          limitMaxLength
          countryCallingCodeEditable={false}
          initialValueFormat='national'
          value={phoneNumber}
          onChange={updateNumberHandler}
          onBlur={onBlurNumberInput}
          aria-labelledby={labelId || `${name}-label`}
          {...testAttributes}
        />
      </Suspense>
    </div>
  );
};

ModernizedPhoneInput.propTypes = themePropTypes.modernizedPhoneInput;

export default ModernizedPhoneInput;
